import { BookArray } from './BookArray';
import { BehaviorSubject, Subscription, Observable } from 'rxjs';
import { AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2/database';
import { NgZone } from '@angular/core'

export class Shelf {
    public static debugMode:boolean = false;

    isOwner:Observable<boolean>
    isPublic:Observable<boolean>
    exists:Observable<boolean>
    isVisible:Observable<boolean>
    
    private bindingActive:boolean = false;
    books:BookArray = null;
    end:BookArray = null;
    
    private shelfRef:firebase.database.Reference;
    private publicShelvesRef:firebase.database.Reference;

    instancesOf:Observable<{[googleId:string]: number}>;
    
                                
    async finishBook(bookKey:string):Promise<void> {
        var book = await this.books.getById(bookKey);
        this.end.addBook(book.googleId, false);
        this.books.deleteBook(bookKey);
    };
    
    async reReadBook(bookKey:string):Promise<void> {
        var book = await this.end.getById(bookKey);
        this.books.addBook(book.googleId, true);
        this.end.deleteBook(bookKey);
    
    };

    
    constructor(private userId:string, public shelfName:string, private shelvableDb:firebase.database.Reference, loggedInUserId:Observable<string>, private db:AngularFireDatabase, private zone:NgZone) {
        NgZone.assertInAngularZone();

        this.shelfRef = shelvableDb.child('users').child(userId).child('bookshelves').child(shelfName);
        this.publicShelvesRef = shelvableDb.child('users').child(userId).child('publicShelves').child(shelfName);        

        if (Shelf.debugMode) {
            console.log('watching loggedInUserId to load shelf ' + userId + '/' + shelfName);
        }

        this.isOwner = loggedInUserId.map((currentUserId) => userId === currentUserId).distinctUntilChanged().shareReplay(1);
        this.isPublic = this.db.object(this.publicShelvesRef)
            .map((val) => val.$exists())
            .do((isPublic) => console.log('shelf ' + (isPublic ? 'is' : 'isn\'t') + ' public'))
            .distinctUntilChanged()
            .shareReplay(1);
            
        this.isVisible = this.isOwner.flatMap((isOwner) => this.isPublic.map((isPublic) => isOwner || isPublic)).distinctUntilChanged().shareReplay(1);
        
        this.exists = this.isVisible.flatMap((isVisible) => isVisible ? this.db.object(this.shelfRef).map((val) => val.$exists()) : Observable.of(false)) 
            .do((exists) => console.log('shelf ' + (exists ? 'exists' : 'doesn\'t exist')))
            .distinctUntilChanged()
            .shareReplay(1);

        var booksList = this.isVisible
            .flatMap((visible) => visible ? this.db.list(this.shelfRef.child('books'), {query: {orderByPriority: true}}) : Observable.of([]))
            .shareReplay(1);

        var endList = this.isVisible
            .flatMap((visible) => visible ? this.db.list(this.shelfRef.child('end'), {query: {orderByPriority: true}}) : Observable.of([]))
            .shareReplay(1);
        
        this.books = new BookArray(booksList, this.db.list(this.shelfRef.child('books')));
        this.end = new BookArray(endList, this.db.list(this.shelfRef.child('end')));

        this.instancesOf = Observable.combineLatest([booksList, endList], (books, end) => {
            var frequencies = {};

            for (var array of [books, end]) {
                for (var book of array) {
                    if (!frequencies[book.googleId]) frequencies[book.googleId] = 0
                    frequencies[book.googleId]++;
                }
            }
            
            return frequencies;
        });

    }
}




// WEBPACK FOOTER //
// ./web/static/services/ShelvableBackend/Shelf.ts